import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookB1 } from './taf-book-b1-list';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class TAFBookB1Service {

    //need to have this somewhere besides hardcoded in here
    //private _tafBookB1Url = ` http://localhost:55706/api/systemmanagement/TAFBookB1`;
    private _tafBookB1Url = `api/systemmanagement/TAFBookB1`;

    constructor(private httpHelper: HttpHelper) { }

    getTAFBookB1(): Observable<ITAFBookB1> {
         return this.httpHelper.get(`${this._tafBookB1Url}`)
             //.map((response: Response) => <ITAFBookB1> response.json())
             //.do(data => console.log('ITafBookB1: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json() || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b1/taf-book-b1.service.ts
 **/